import { FC, useEffect } from "react";
import { useIntl } from "react-intl";
import { PageTitle, usePageData } from "../../../_metronic/layout/core";
import { ActivityGrid } from "./ActivityGrid";

const ActivityPage: FC = () => <ActivityGrid />;

const ActivityWrapper: FC = () => {
    const { setPageToolbarLinks } = usePageData();
    const intl = useIntl();
    useEffect(() => {
        setPageToolbarLinks([]);
    }, []);

    return (
        <>
            <PageTitle>{intl.formatMessage({ id: "layout.log.title" })}</PageTitle>
            <ActivityPage />
        </>
    );
};

export default ActivityWrapper;
